/**************** List权限 ****************/
export const PRICE_COMPARE_LIST_PAGE_UUID =
  '5d202606-a6f2-4f42-b0b3-b82c693fb40a'

/**************** 操作权限 ****************/
// 审核
export const PRICE_COMPARE_APPROVE_ACTION_UUID =
  'd72db83f-19df-46ee-8581-53f458bcf1a4'

// 编辑
export const PRICE_COMPARE_EDIT_ACTION_UUID =
  '9f5a05f9-9754-4240-908b-9c165d8c6290'

// 竞价会员
export const PRICE_COMPARE_MEMBERS_ACTION_UUID =
  '73f4bb49-2cfc-45e2-9130-4ce73826a8c0'

// 竞价会员——管理按钮
export const PRICE_COMPARE_MEMBERS_MANAGE_ACTION_UUID =
  '2e935868-96e8-4894-98db-3fb589949fe9'
